function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><title>down_job</title><g fill="#DE002E" fillRule="nonzero"><path d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm0-1.818a8.182 8.182 0 1 1 0-16.364 8.182 8.182 0 0 1 0 16.364z" /><path d="M2.93 4.216L15.784 17.07a.91.91 0 1 0 1.286-1.286L4.216 2.93A.91.91 0 1 0 2.93 4.216z" /></g></svg>;
});